import { StyleColorSchemeType } from '@/ui-kit/styles/enums';
import { StyleFillType } from '../../input/enums';
import { MinMaxSelectProperty, MinMaxSelectVariant } from '../enums';

const MinMaxSelectProps = {
  props: {
    [MinMaxSelectProperty.ClassName]: {
      default: '',
      type: String,
    },
    [MinMaxSelectProperty.Value]: {
      default: () => ({
        min: null,
        max: null,
        action: '',
      }),
      type: Object,
    },
    [MinMaxSelectProperty.Label]: {
      default: '',
      type: String,
    },
    [MinMaxSelectProperty.MinValues]: {
      default: () => [],
      type: Array,
    },
    [MinMaxSelectProperty.MaxValues]: {
      default: () => [],
      type: Array,
    },
    [MinMaxSelectProperty.IconColor]: {
      default: StyleColorSchemeType.Secondary,
      type: String,
    },
    [MinMaxSelectProperty.ColorScheme]: {
      default: StyleColorSchemeType.SecondaryLight,
      type: String,
    },
    [MinMaxSelectProperty.LabelColorScheme]: {
      default: StyleColorSchemeType.Gray,
      type: String,
    },
    [MinMaxSelectProperty.FillType]: {
      default: StyleFillType.Underlined,
      type: String,
    },
    [MinMaxSelectProperty.Disabled]: {
      default: false,
      type: Boolean,
    },
    [MinMaxSelectProperty.IsReadonly]: {
      default: true,
      type: Boolean,
    },
    [MinMaxSelectProperty.Variant]: {
      type: String,
      default: MinMaxSelectVariant.Dropdown,
    },
  },
};

export default MinMaxSelectProps;
